export default "__VITE_ASSET__DCFYnWtg__"